import React, { useState } from "react";
import budowie from '../../assets/images/Po-budowie.svg';
import maszynowe from '../../assets/images/maszynowe.svg';
import remoncie from '../../assets/images/Po-remonte.svg';
import okien from '../../assets/images/Okien.svg';
import utrzymanie from '../../assets/images/utrzymanie.svg';
import './UslugiTab.scss';

export const UslugiTab = () => {
    const [activeTab, setActiveTab] = useState(1); // устанавливаем начальный активный таб

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };

    return (
        <section className="section-uslugi">
            <div className="container">
                <h4>Услуги</h4>
                <div className="tabs-wrapp">
                    <div className="tabs">
                        <button
                            className={activeTab === 1 ? "tab active-tab" : "tab"}
                            onClick={() => handleTabClick(1)}
                        >
                            Уборка после строительства
                        </button>
                        <button
                            className={activeTab === 2 ? "tab active-tab" : "tab"}
                            onClick={() => handleTabClick(2)}
                        >
                            Машинная чистка
                        </button>
                        <button
                            className={activeTab === 3 ? "tab active-tab" : "tab"}
                            onClick={() => handleTabClick(3)}
                        >
                            Уборка после ремонта
                        </button>
                        <button
                            className={activeTab === 4 ? "tab active-tab" : "tab"}
                            onClick={() => handleTabClick(4)}
                        >
                            Мойка окон
                        </button>
                        <button
                            className={activeTab === 5 ? "tab active-tab" : "tab"}
                            onClick={() => handleTabClick(5)}
                        >
                            ПОДДЕРЖАНИЕ ЧИСТОТЫ
                        </button>
                    </div>
                    <div className="tab-content-wrapp">
                        {activeTab === 1 && (
                            <div className="tab-content">
                                <span>Полная уборка помещений после строительных работ, пылесосение, чистка полов и покрытий. Очистка всех поверхностей от остатков строительных материалов. Вынос строительного мусора.</span>
                                <div><img src={budowie} alt="" /></div>
                            </div>
                        )}
                        {activeTab === 2 && (
                            <div className="tab-content">
                                <span>Машинная мойка полов в гаражах, логистических центрах, производственных цехах, парковках, пищевых и фармацевтических помещениях, школьных и спортивных объектах, складах, мойка и чистка лестничных клеток, чистка ковровых покрытий различных типов.</span>
                                <div><img src={maszynowe} alt="" /></div>
                            </div>
                        )}
                        {activeTab === 3 && (
                            <div className="tab-content">
                                <span>Очистка всех поверхностей от строительной пыли, вынос мусора, удаление остатков клея, засохшей краски и следов строительных смесей.</span>
                                <div className="po-remonte"><img src={remoncie} alt="" /></div>
                            </div>
                        )}
                        {activeTab === 4 && (
                            <div className="tab-content">
                                <span>Мойка окон и рам (пластиковых, деревянных, алюминиевых), стеклянных ограждений и зеркал. Чистка витрин, рекламных баннеров, остекления любого типа, а также мойка солнечных панелей.</span>
                                <div><img src={okien} alt="" /></div>
                            </div>
                        )}
                        {activeTab === 5 && (
                            <div className="tab-content">
                                <span className="utrzymanie">
                                    - уборка офисов, торговых помещений, объектов общественного питания, промышленных объектов, складов и т.д.<br/>
                                    - регулярные и разовые услуги
                                </span>
                                <div><img src={utrzymanie} alt="" /></div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};